import React, { useState } from 'react';
import { i18n_watch_trailer } from '@yi/i18n/phrases/i18n_watch_trailer';

import { isMediaId, MediaId } from '~/common';
import { IconPlayTurquoise } from '~/src/components/icons';
import { useLocale } from '~/src/components/LocaleProvider';
import { Autoplay, BasicPlayer, MediaPlayerModal } from '~/src/components/MediaPlayer';

import { Button } from './elements';

type Props = {
  mediaId: MediaId | null;
};

export const WatchTrailerButton: React.FC<Props> = ({ mediaId }) => {
  const [showVideoModal, setShowVideoModal] = useState(false);
  const { locale } = useLocale();
  if (!isMediaId(mediaId)) {
    return null;
  }
  return (
    <>
      <Button onClick={() => setShowVideoModal(true)}>
        <IconPlayTurquoise />
        {i18n_watch_trailer(locale)}
      </Button>
      <MediaPlayerModal open={showVideoModal} onClose={() => setShowVideoModal(false)}>
        <BasicPlayer mediaId={mediaId}>
          <Autoplay />
        </BasicPlayer>
      </MediaPlayerModal>
    </>
  );
};
